import { create } from 'zustand';

interface MediaState {
  localStream: MediaStream | null;
  audioEnabled: boolean;
  videoEnabled: boolean;
  screenShareEnabled: boolean;
  blurBackground: boolean;
  audioDeviceId: string | null;
  videoDeviceId: string | null;
  audioOutputDeviceId: string | null;
  audioDevices: MediaDeviceInfo[];
  videoDevices: MediaDeviceInfo[];
  audioOutputDevices: MediaDeviceInfo[];
  
  setLocalStream: (stream: MediaStream | null) => void;
  setAudioEnabled: (enabled: boolean) => void;
  setVideoEnabled: (enabled: boolean) => void;
  setScreenShareEnabled: (enabled: boolean) => void;
  setBlurBackground: (enabled: boolean) => void;
  setAudioDeviceId: (deviceId: string) => void;
  setVideoDeviceId: (deviceId: string) => void;
  setAudioOutputDeviceId: (deviceId: string) => void;
  setDevices: (audio: MediaDeviceInfo[], video: MediaDeviceInfo[], audioOutput: MediaDeviceInfo[]) => void;
  reset: () => void;
}

export const useMediaStore = create<MediaState>((set) => ({
  localStream: null,
  audioEnabled: true,
  videoEnabled: true,
  screenShareEnabled: false,
  blurBackground: false,
  audioDeviceId: null,
  videoDeviceId: null,
  audioOutputDeviceId: null,
  audioDevices: [],
  videoDevices: [],
  audioOutputDevices: [],

  setLocalStream: (stream) => set({ localStream: stream }),
  
  setAudioEnabled: (enabled) => set({ audioEnabled: enabled }),
  
  setVideoEnabled: (enabled) => set({ videoEnabled: enabled }),
  
  setScreenShareEnabled: (enabled) => set({ screenShareEnabled: enabled }),
  
  setBlurBackground: (enabled) => set({ blurBackground: enabled }),
  
  setAudioDeviceId: (deviceId) => set({ audioDeviceId: deviceId }),
  
  setVideoDeviceId: (deviceId) => set({ videoDeviceId: deviceId }),
  
  setAudioOutputDeviceId: (deviceId) => set({ audioOutputDeviceId: deviceId }),
  
  setDevices: (audio, video, audioOutput) =>
    set({
      audioDevices: audio,
      videoDevices: video,
      audioOutputDevices: audioOutput,
    }),

  reset: () =>
    set({
      localStream: null,
      audioEnabled: true,
      videoEnabled: true,
      screenShareEnabled: false,
      blurBackground: false,
      audioDeviceId: null,
      videoDeviceId: null,
      audioOutputDeviceId: null,
    }),
}));
